const { getResultPrice } = require('./search-result-links');

const getComparablePrice = result => {
  const price = getResultPrice(result);
  return price === null ? Infinity : price;
};

const dedupeSearchMapResults = results => {
  const resultsByPropertyId = new Map();
  (Array.isArray(results) ? results : []).forEach((result, index) => {
    const propertyId =
      result.property && result.property.id !== undefined
        ? String(result.property.id)
        : `result-${index}`;
    const currentResult = resultsByPropertyId.get(propertyId);
    if (
      !currentResult ||
      getComparablePrice(result) < getComparablePrice(currentResult)
    ) {
      resultsByPropertyId.set(propertyId, result);
    }
  });
  return Array.from(resultsByPropertyId.values());
};

module.exports = dedupeSearchMapResults;
